'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Authentication = require('./Authentication');

var _Authentication2 = _interopRequireDefault(_Authentication);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Private Members
var contentType = Symbol('The content type for the request');
var config = Symbol('The config for the request');
var token = Symbol('The token for the request');

var isAuthenticated = Symbol('This private method will be used to ensure the user is authenticated');
var setConfig = Symbol('This private method will be used to set the config for axios');

var Bottle = function () {
  function Bottle() {
    _classCallCheck(this, Bottle);

    // axios.defaults.withCredentials = true // Cookie is not required for calls other than tokenApi
    this[contentType] = '';
    this[config] = {};
    this[token] = {};
  }

  // private methods


  _createClass(Bottle, [{
    key: isAuthenticated,
    value: function value() {
      var authentication = new _Authentication2.default();

      this[token] = authentication.getAuthenticationToken();

      if (!this[token]) {
        return false;
      }

      return this[token].access_token.length > 0;
    }
  }, {
    key: setConfig,
    value: function value(config) {
      var auth = void 0;
      var type = 'application/json';

      if (this[isAuthenticated]()) {
        auth = 'Bearer ' + this[token].access_token;
      }

      if (!config) {
        config = {};
      }

      if (!config.headers) {
        config.headers = {};
      }

      if (!config.headers.contentType) {
        config.headers.contentType = type;
      }
      config.headers.authorization = auth;
      config.headers.accept = type;

      return config;
    }
  }, {
    key: 'get',
    value: function get(url, config) {
      try {
        this[config] = this[setConfig](config);
        return _axios2.default.get(url, this[config]);
      } catch (e) {
        throw e;
      }
    }
  }, {
    key: 'post',
    value: function post(url, data, config) {
      try {
        this[config] = this[setConfig](config);
        return _axios2.default.post(url, data, this[config]);
      } catch (e) {
        throw e;
      }
    }
  }, {
    key: 'put',
    value: function put(url, data, config) {
      try {
        this[config] = this[setConfig](config);
        return _axios2.default.put(url, data, this[config]);
      } catch (e) {
        throw e;
      }
    }
  }, {
    key: 'patch',
    value: function patch(url, data, config) {
      try {
        this[config] = this[setConfig](config);
        return _axios2.default.patch(url, data, this[config]);
      } catch (e) {
        throw e;
      }
    }
  }, {
    key: 'delete',
    value: function _delete(url, config) {
      try {
        this[config] = this[setConfig](config);
        return _axios2.default.delete(url, this[config]);
      } catch (e) {
        throw e;
      }
    }
  }, {
    key: 'contentType',
    get: function get() {
      return this[contentType];
    },
    set: function set(contentType) {
      if (contentType) {
        this[contentType] = contentType;
      }
    }
  }]);

  return Bottle;
}();

exports.default = Bottle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ctxs-vue-plugins/dist/classes/Bottle.js
// module id = gcEe
// module chunks = 0